// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { doc, getDoc } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBLW7rC41yYaIRjsfHGVNf6auFUXqRiKs4",
  authDomain: "trackoria-55e2e.firebaseapp.com",
  projectId: "trackoria-55e2e",
  storageBucket: "trackoria-55e2e.appspot.com",
  messagingSenderId: "138712508117",
  appId: "1:138712508117:web:2f1fa760bb2949fed4a45c",
  measurementId: "G-DJ6LLN177F",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);

// const docRef = doc(db, "groceries");
// const docSnap = await getDoc(docRef);


